export default "__VITE_ASSET__DXIsuhnh__"